var module = angular.module('octopusApp.configuration');

module.controller('SubscriptionEditController', function($scope, $stateParams, $location, busy, pageTitle, octopusRepository, octopusTagSets, octoDialog, unsavedChanges, systemUserFactory) {
    var vm = this;
    var isLoading = vm.isLoading =  $scope.isLoading = busy.create();
    var isSaving = vm.isSaving = $scope.isSaving = busy.create();
    var subscriptionId = $stateParams.subscriptionId;
    var repository = octopusRepository.Subscriptions;
    var systemUser = systemUserFactory;

    vm.subscription = null;
    vm.smtpConfigured = false;
    vm.serverUriExists = false;
    vm.serverUri = undefined;

    vm.selectedValues = {
        users: [],
        projects: [],
        environments: [],
        eventGroups: [],
        eventCategories: [],
        tenants: [],
        tagSets: [],
        selectedEventGroupCategories: []
    };

    vm.save = function() {
        if (vm.emailFrequencyPeriod.Days == null) {
            vm.emailFrequencyPeriod.Days = 0;
        }
        if (vm.emailFrequencyPeriod.Hours == null) {
            vm.emailFrequencyPeriod.Hours = 0;
        }
        if (vm.emailFrequencyPeriod.Minutes == null) {
            vm.emailFrequencyPeriod.Minutes = 0;
        }

        vm.subscription.EventNotificationSubscription.EmailFrequencyPeriod = vm.emailFrequencyPeriod.Days + "." + pad(vm.emailFrequencyPeriod.Hours) + ":" + pad(vm.emailFrequencyPeriod.Minutes) + ":00";

        mapSelectedValuesToSubscription();

        isSaving.promise(repository.save(vm.subscription).then(function(saved){
            unsavedChanges.saved();
            $location.path('/configuration/audit/subscriptions/');
        }));
    };

    var getTags = function(selectedOptions, allOptions) {
        if (!selectedOptions || selectedOptions.length === 0 || allOptions.length === 0) {
            return "";
        }
        var selectedOptionsArray = selectedOptions.split(",");
        var result = [];
        _.each(allOptions, function (e) {
            if (_.contains(selectedOptionsArray, e.Id)) {
                result.push(e.Name);
            }
        });
        return result.join(",");
    };

    function mapSubscriptionToSelectedValues()
    {
        vm.selectedValues.users = vm.subscription.EventNotificationSubscription.Filter.Users;
        vm.selectedValues.projects = vm.subscription.EventNotificationSubscription.Filter.Projects;
        vm.selectedValues.environments = vm.subscription.EventNotificationSubscription.Filter.Environments;
        vm.selectedValues.eventGroups = vm.subscription.EventNotificationSubscription.Filter.EventGroups;
        vm.selectedValues.eventCategories = vm.subscription.EventNotificationSubscription.Filter.EventCategories;
        vm.selectedValues.tenants = vm.subscription.EventNotificationSubscription.Filter.Tenants;
        vm.selectedValues.tagSets = vm.subscription.EventNotificationSubscription.Filter.Tags;
    }

    function mapSelectedValuesToSubscription()
    {
        vm.subscription.EventNotificationSubscription.Filter.Users = vm.selectedValues.users;
        vm.subscription.EventNotificationSubscription.Filter.Projects = vm.selectedValues.projects;
        vm.subscription.EventNotificationSubscription.Filter.Environments = vm.selectedValues.environments;
        vm.subscription.EventNotificationSubscription.Filter.EventGroups = vm.selectedValues.eventGroups;
        vm.subscription.EventNotificationSubscription.Filter.EventCategories = vm.selectedValues.eventCategories;
        vm.subscription.EventNotificationSubscription.Filter.Tenants = vm.selectedValues.tenants;
        vm.subscription.EventNotificationSubscription.Filter.Tags = vm.selectedValues.tagSets;
    }

    function extractFilterParams() {
        if ($location.search().users){
            var usersVal = $location.search().users;
            if (typeof usersVal === "string") {
                usersVal = [usersVal];
            }
            vm.selectedValues.users = usersVal;
        }
        if ($location.search().projects){
            var projectsVal = $location.search().projects;
            if (typeof projectsVal === "string") {
                projectsVal = [projectsVal];
            }
            vm.selectedValues.projects = projectsVal;
        }
        if ($location.search().environments){
            var environmentsVal = $location.search().environments;
            if (typeof environmentsVal === "string") {
                environmentsVal = [environmentsVal];
            }
            vm.selectedValues.environments = environmentsVal;
        }
        if ($location.search().eventGroups){
            var eventGroupsVal = $location.search().eventGroups;
            if (typeof eventGroupsVal === "string") {
                eventGroupsVal = [eventGroupsVal];
            }
            vm.selectedValues.eventGroups = eventGroupsVal;
        }
        if ($location.search().eventCategories){
            var eventCategoriesVal = $location.search().eventCategories;
            if (typeof eventCategoriesVal === "string") {
                eventCategoriesVal = [eventCategoriesVal];
            }
            vm.selectedValues.eventCategories = eventCategoriesVal;
        }
        if ($location.search().tenants){
            var tenantVal = $location.search().tenants;
            if (typeof tenantVal === "string") {
                tenantVal = [tenantVal];
            }
            vm.selectedValues.tenants = tenantVal;
        }
        if ($location.search().tags){
            var tagVal = $location.search().tags;
            if (typeof tagVal === "string") {
                tagVal = [tagVal];
            }
            vm.selectedValues.tagSets = tagVal;
        }
    }

    function refreshEmailFrequencyPeriod() {
        var emailFrequencyPeriodParts = vm.subscription.EventNotificationSubscription.EmailFrequencyPeriod.split(":");

        var days = 0;
        var hours = 0;
        var mins = 0;
        var tsPart1 = emailFrequencyPeriodParts[0];
        if (tsPart1.indexOf(".") !== -1) {
            // days included
            var daysAndHours = tsPart1.split(".");
            days = parseInt(daysAndHours[0]);
            hours = parseInt(daysAndHours[1]);
            mins = parseInt(emailFrequencyPeriodParts[1]);
        } else {
            // no days
            hours = parseInt(emailFrequencyPeriodParts[0]);
            mins = parseInt(emailFrequencyPeriodParts[1]);
        }
        vm.emailFrequencyPeriod = {
            Days: days,
            Hours: hours,
            Minutes: mins
        };
    }

    function pad(num){
        return ("00" + num).substr(-2);
    }


    function init() { 
        var promises = [];
        promises.push(octopusRepository.Teams.all().then(function(teams) {
            vm.teams = teams;
        }));
        promises.push(octopusRepository.SmtpConfiguration.get().then(function (smtp) {
            if (smtp.SmtpHost && smtp.SmtpPort > 0 && smtp.SendEmailFrom) {
                vm.smtpConfigured = true;
            }
        }));
        promises.push(octopusRepository.ServerConfiguration.get().then(function (config) {
            if (config.ServerUri) {
                vm.serverUri = config.ServerUri;
                vm.serverUriExists = true;
            }
        }));
        promises.push(octopusRepository.Users.all().then(function(users) {
            vm.usersByUsername = {};
            vm.users = users;
            vm.users.unshift(systemUser);
            _.each(users, function(user) {
                vm.usersByUsername[user.Username] = user;
            });
        }));
        promises.push(octopusRepository.Projects.all().then(function(projects) {
            vm.projects = projects;
        }));
        promises.push(octopusRepository.Environments.all().then(function(environments) {
            vm.environments = environments;
        }));
        promises.push(octopusRepository.Events.categories().then(function (eventCategories) {
            vm.eventCategories = eventCategories;
        }));
        promises.push(octopusRepository.Events.groups().then(function (eventGroups) {
            vm.eventGroups = eventGroups;
        }));
        if (octopusRepository.Tenants) {
            promises.push(octopusTagSets.getAll().then(function (tagSets) {
                vm.tagSets = tagSets.filter(function (ts) {
                    return ts.Tags.length > 0;
                });
            }));
            promises.push(octopusRepository.Tenants.all().then(function (tenants) {
                vm.availableTenants = tenants;
            }));
        }
        promises.push(octopusRepository.ServerStatus.getTimezones().then(function (timezones) {
            vm.timezones = timezones;
        }));

        isLoading.promises(promises).then(function() {
            if (subscriptionId) {
                isLoading.promise(repository.get(subscriptionId).then(function (subscription) {
                    vm.subscription = subscription;
                    refreshEmailFrequencyPeriod();
                    mapSubscriptionToSelectedValues();
                    pageTitle(subscription.Name);
                }));
            } else {
                var serverLocalTimezones = vm.timezones.filter(function(tz) {
                    return tz.IsLocal === true;
                });
                vm.subscription = {
                    Name: "",
                    Type: "Event",
                    EventNotificationSubscription: {
                        Filter: {
                            Users: [],
                            Projects: [],
                            Environments: [],
                            EventGroups: [],
                            EventCategories: [],
                            Tenants: [],
                            Tags: []
                        },
                        EmailFrequencyPeriod: "0.01:00",
                        EmailShowDatesInTimeZoneId: (serverLocalTimezones.length > 0 ? serverLocalTimezones[0].Id : null),
                        Teams: []
                    }
                };
                mapSubscriptionToSelectedValues();
                refreshEmailFrequencyPeriod();
                extractFilterParams();
                pageTitle('Create Subscription');
            }
        });
    }

    init();
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/audit/subscriptions/controllers/subscription_edit_controller.js
// module id = 380
// module chunks = 1